import cx from 'classnames';
import type { FC, PropsWithChildren, ReactNode } from 'react';

import { WIZARD_ZINDEX } from '@zen/Layout';

interface Props {
  footer: ReactNode;
  masthead: ReactNode;
  stepper: ReactNode;
}

const WizardLayout: FC<PropsWithChildren<Props>> = (props) => {
  const { children, footer, masthead, stepper } = props;

  const classNames: string = cx('fixed inset-0 flex flex-col bg-white', WIZARD_ZINDEX);

  return (
    <div className={classNames} data-component="wizard-layout">
      {masthead}
      {stepper}
      <main className="flex-1 overflow-y-auto">
        <div className="mx-auto w-full max-w-6xl px-6 py-8">{children}</div>
      </main>
      {footer}
    </div>
  );
};

export type { Props as WizardLayoutProps };
export default WizardLayout;
